import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Profile() {
  const { user, organization } = useAuth();

  return (
    <div className="account-page">
      <header className="account-page-head">
        <h1>Profile</h1>
        <p className="muted">Your sign-in identity and organization membership.</p>
      </header>

      <section className="account-section">
        <div className="kv">
          <div className="kv-row"><span className="kv-label">Email</span><pre>{user?.email}</pre></div>
          <div className="kv-row"><span className="kv-label">Name</span><pre>{user?.display_name || <em>—</em>}</pre></div>
          <div className="kv-row"><span className="kv-label">Organization</span><pre>{organization?.name}</pre></div>
          <div className="kv-row"><span className="kv-label">Role</span><pre>{organization?.role}</pre></div>
        </div>
      </section>
    </div>
  );
}
